<template>
    <div>
        <div class="alert alert-info" role="alert" v-if="status == -1">
            Confirming your e-mail address...
        </div>
        <div class="alert alert-success" role="alert" v-if="status == 1">
            Thank you! Your e-mail address is now confirmed.
        </div>
        <div class="alert alert-danger" role="alert" v-if="status == 0">
            Your e-mail address could not be confirmed or is already confirmed.
        </div>
    </div>
</template>

<script>
import * as api from '@/api';

export default {
    name: 'user-confirmation',
    data() {
        return {
            status: -1,
        };
    },
    created() {
        api.users.confirmation({ confirmationToken: this.$route.query.confirmation_token }).then(
            () => {
                this.status = 1;
            },
            () => {
                this.status = 0;
            }
        );
    },
};
</script>
